import { NavLink as RNavLink } from "react-router";

export default function NavLink({
	href,
	icon: Icon,
	collapsed,
	onClick,
	children,
}) {
	const Component =
		href.startsWith("http") ||
		[TRIPADMIN_URL, WEBSITE_URL].some((path) => href.startsWith(path))
			? "a"
			: RNavLink;
	const isExternal = Component === "a";
	return (
		<Component
			{...(isExternal
				? { href, target: "_blank", rel: "noopener noreferrer" }
				: { to: href })}
			className={`font-sans-wide flex items-center gap-4  p-4 ${collapsed ? "mx-auto" : "md:px-8"} md:py-6 hover:bg-trans-15`}
			onClick={onClick}
		>
			<Icon className="text-white w-6 h-6 min-w-6 md:w-8 md:h-8 md:min-w-8" />
			{!collapsed && (
				<span className="flex-1 text-sm md:text-lg">{children}</span>
			)}
		</Component>
	);
}
